// extracted by mini-css-extract-plugin
export var locationCard = "_ig-0";